import $axios from './http';
import axios from 'axios';
import userEquipmentInfo from './userEquipmentInfo.js';
const { infoPhone, bs } = userEquipmentInfo();

function date1() {
  const a = new Date();
  const year = a.getFullYear();
  const month = a.getMonth() + 1;
  const day = a.getDate();
  return `${year}-${month > 9 ? month : `0${month}`}-${day > 9 ? day : `0${day}`}`;
}

function date2() {
  const a = new Date();
  const hour = a.getHours();
  const minutes = a.getMinutes();
  const seconds = a.getSeconds();
  return `${hour > 9 ? hour : `0${hour}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`;
}

class publishApi {
  async statisticsApi(et: number) {
    try {
      const res = await $axios.post(
        `/touch/bookstore.do`,
        `value=${encodeURI(
          JSON.stringify({
            ...infoPhone,
            type: 'backstatistics',
            body: {
              event_list: [
                {
                  event_id: et,
                  event_time: `${date1()} ${date2()}`,
                },
              ],
            },
          })
        )}`
      );
    } catch (e) {}
  }

  async getListApi(successCb: Function, errorCb: Function) {
    try {
      const res = await $axios.post(
        `/touch/bookstore.do`,
        `value=${encodeURI(
          JSON.stringify({
            ...infoPhone,
            type: 'nav_list',
            body: {},
          })
        )}`
      );
      if (res.data.result === '0000') {
        successCb && successCb(res.data.body.nav_list);
      }
    } catch (e) {}
  }
}

export default new publishApi();
